import {TheCageSymbol, TheCageSymbolStates} from "../TheCageSymbol";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {gsap} from "gsap";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {TheCageSound} from "../../sound/TheCageSound";


export class GloveSymbol extends TheCageSymbol {
    private readyToDestroy:boolean = true;


    constructor(symbolName:string, initState:TheCageSymbolStates, reelsView: ReelView) {
        super(symbolName, initState, reelsView);
    }

    getStateAnimation(state:TheCageSymbolStates):gsap.core.Timeline {
        return super.getStateAnimation(state);
    }

    protected getLandingAnimation(state:TheCageSymbolStates):gsap.core.Timeline {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName);
        tl.add(() => this.moveToWinLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                spine.updateTransform();
                this.setState(TheCageSymbolStates.LANDING, "none");
            })
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, "landing",0,1,0));
        }

        return tl;
    }

    public getPunchAnimation():gsap.core.Timeline {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName);
        tl.add(() => this.moveToWinLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                spine.updateTransform();
            })
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, "punch",0,1,0));
        }

        return tl;
    }
}
